<template>
    <div class="layout-align field-wrap">
        <ul
            class="layout-align__list"
            :class="'layout-align__list--count-' + Object.keys(options).length"
        >
            <li
                v-for="(options__value, options__key) in options"
                v-bind:key="id + '_' + options__key"
                class="layout-align__list-element"
            >
                <input
                    type="radio"
                    :id="id + '_' + options__key"
                    v-model="simpleFieldModel"
                    :value="Array.isArray(options) ? options__value : options__key"
                    class="layout-align__input"
                />
                <label
                    :for="id + '_' + options__key"
                    class="layout-align__label"
                    :class="'layout-align__label--' + options__value"
                    >{{ options__value }}</label
                >
            </li>
        </ul>
    </div>
</template>

<script>
import pushid from 'pushid';
import { SimpleFieldMixin } from '@/mixins/SimpleFieldMixin';

export default {
    data() {
        return {
            id: pushid()
        };
    },
    components: {},
    methods: {},
    computed: {},
    mixins: [SimpleFieldMixin],
    props: {
        options: [Object, Array]
    }
};
</script>
